export default __webpack_public_path__ + "static/media/sub-topic-model-08.f03e0666.glb";